import api, { Base } from 'ev-api/api';
import { sanitizeAndTransformResponseDataAttributes } from 'ev-api/common/transformers';
import { BulkImportReport } from 'ev-types/bulk-user-import';

import { GetBulkImportParams } from './params';

const BulkUserImportApi = api.injectEndpoints({
  endpoints: builder => ({
    getBulkImportStatus: builder.query<BulkImportReport, GetBulkImportParams>({
      query: ({ bulkId }) => ({
        url: `${Base.V3}/bulk_user_imports/${bulkId}`,
        method: 'GET',
      }),
      transformResponse: sanitizeAndTransformResponseDataAttributes,
    }),
    cancelBulkImport: builder.mutation<void, GetBulkImportParams>({
      query: ({ bulkId }) => ({
        url: `${Base.V3}/bulk_user_imports/${bulkId}/cancel`,
        method: 'POST',
      }),
    }),
    executeBulkImport: builder.mutation<void, GetBulkImportParams>({
      query: ({ bulkId }) => ({
        url: `${Base.V3}/bulk_user_imports/${bulkId}/execute`,
        method: 'PUT',
      }),
    }),
  }),
});

export const {
  useGetBulkImportStatusQuery,
  useCancelBulkImportMutation,
  useExecuteBulkImportMutation,
} = BulkUserImportApi;
